import type { BindingFormat } from '@safetyhub/shared';

/**
 * 표시 형식(BindingFormat)의 한글 이름 — **화면·매뉴얼 공통 정본**.
 *
 * 속성 패널 '표시 형식' select가 이 이름을 쓰고, 매뉴얼 레퍼런스(r3) 생성기도
 * 이 파일에서 이름 열을 추출한다. 같은 사실을 두 벌로 두면 드리프트가 나므로
 * 이름은 여기서만 소유한다(매뉴얼 쪽 `scripts/manual/registries/composer-copy.mjs`는
 * 설명문만 소유).
 *
 * `Record<BindingFormat['kind'], string>`으로 결속돼 있어, 새 형식을 추가하면
 * tsc가 여기 누락을 잡는다.
 */
export const BINDING_FORMAT_LABELS: Record<BindingFormat['kind'], string> = {
  unit: '단위 붙이기',
  date: '날짜 모양',
  url: '파일 주소',
  // 2026-09-05 재개명(구 「문구 끼워넣기」): 목적어가 뒤집혀 읽혔다 — 실제 동작은 미리 써 둔
  // 문구 *속에* 값을 넣는 것인데, 구 이름은 문구를 어딘가에 끼우는 것처럼 읽힌다.
  template: '문구에 값 넣기',
  default: '빈 값 대체',
  join: '목록 이어 붙이기',
  map: '값 바꿔 쓰기',
  switch: '다른 항목에 따라',
  rangeMap: '구간 판정',
  bool: '체크 표시',
};

/** 형식을 고르지 않은 상태(select의 첫 항목). */
export const BINDING_FORMAT_NONE_LABEL = '없음';

/**
 * select 옵션 표기 — `한글 이름 (코드 값)`.
 * 운영자는 한글로 찾고, 문서·개발자는 코드 값으로 대조한다.
 */
export function bindingFormatOptionLabel(kind: BindingFormat['kind'] | 'none'): string {
  const name = kind === 'none' ? BINDING_FORMAT_NONE_LABEL : BINDING_FORMAT_LABELS[kind];
  return `${name} (${kind})`;
}
